module.exports = __webpack_public_path__ + "static/media/bean2.13d4e75a.png";